import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-20">
        <h1
          className="font-serif text-4xl md:text-5xl text-charcoal mb-4"
          data-testid="shipping-policy-title"
        >
          Shipping Policy
        </h1>

        <p className="text-sm text-[#6B665F]">Siyaanish – Live Your Values</p>
        <p className="text-sm text-[#6B665F] mb-8">
          {/* Last updated: [Add Date] */}
          </p>

        <p className="text-[#6B665F] leading-relaxed mb-12">
          Siyaanish operates on a conscious, small-batch production model.
          Please read our shipping policy carefully before placing an order.
        </p>

        <div className="space-y-10 text-[#6B665F] leading-relaxed font-light">

          {/* 1 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              1. Shipping Locations
            </h2>
            <p className="mb-2">We ship:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Across India</li>
              <li>Internationally</li>
            </ul>
            <p className="mt-3">
              Shipping charges (if applicable) will be calculated at checkout.
            </p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              2. Dispatch Timeline
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Typical dispatch timeline: 7–14 working days</li>
              <li>Dispatch time depends on:</li>
            </ul>

            <ul className="list-disc pl-12 mt-2 space-y-2">
              <li>Product type (ready stock / made-to-order / small batch)</li>
              <li>Material availability</li>
              <li>Production timelines</li>
            </ul>

            <p className="mt-3">
              Dispatch timelines are estimates, not guarantees.
            </p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              3. Delivery Timeline
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Delivery timelines vary by location and courier partner</li>
              <li>International deliveries may be subject to customs clearance delays</li>
            </ul>
            <p className="mt-3">
              Siyaanish is not responsible for delays caused by logistics providers,
              customs authorities, strikes, or unforeseen circumstances.
            </p>
          </section>

          {/* 4 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              4. Courier Responsibility
            </h2>
            <p className="mb-2">Once an order is dispatched:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Responsibility transfers to the courier partner</li>
              <li>Tracking details will be shared via email</li>
            </ul>
          </section>

          {/* 5 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              5. Customs & Duties (International Orders)
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Customs duties, taxes, or import charges (if applicable) are the
                responsibility of the customer
              </li>
              <li>
                Siyaanish has no control over customs clearance timelines
              </li>
            </ul>
          </section>

          {/* 6 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              6. Incorrect Address
            </h2>
            <p>
              Please ensure your shipping details are accurate. Siyaanish is not
              responsible for delays or losses caused by incorrect or incomplete
              address information.
            </p>
          </section>

          {/* 7 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              7. Contact
            </h2>
            <p>
              For shipping-related queries, contact{' '}
              <a
                href="mailto:info@siyaanish.com"
                className="text-bronze hover:text-bronze-dark"
              >
                info@siyaanish.com
              </a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;